<template>
  <div>
    <div style="margin-bottom: 5px; margin-top: 5px">
      <el-button @click="excelPost(1)">打印</el-button>
      <el-button @click="excelPost(2)">纵向打印</el-button>
    </div>
    <div class="cdj_div" style="margin-top: 10px">
      公设费收支管控表-查询条件
    </div>
    <el-descriptions
      :column="2"
      border
      size="mini"
      :labelStyle="{ width: '123px', color: 'black' }"
      :contentStyle="{ width: '42%' }"
    >
      <el-descriptions-item label="房产">
        <div style="display: flex">
          <div
            @click="houses"
            v-if="data.house"
            style="cursor: pointer; color: red"
            :class="data.house.length > 30 ? 'dade-text' : ''"
          >
            {{ data.house }}
          </div>
          <div
            @click="houses_del"
            v-if="data.house"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="houses" v-else style="cursor: pointer">选择房产...</div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="费用类型">
        <div style="display: flex">
          <div
            @click="chargeitems"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; color: red"
            :class="data.chargeitemIDName.length > 30 ? 'dade-text' : ''"
          >
            {{ data.chargeitemIDName }}
          </div>
          <div
            @click="chargeitems_del"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="chargeitems" v-else style="cursor: pointer">
            选择收费项目...
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <!-- 房产 -->
    <house ref="house"></house>
    <!-- 收费项目 -->
    <Chargeitem ref="chargeitem" @chargeitemAll="chargeitemAll"></Chargeitem>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ExcelTask from "@/components/common/excelTask";
import House from "@/components/Admin/Forms/common/SelectProjectHouse";
import Chargeitem from "@/components/Admin/Forms/common/Chargeitem";
export default {
  name: "AmenityForm",
  components: {
    "room-user": () => import("../Common/room-user.vue"),
    House,
    Chargeitem,
    ExcelTask,
  },
  data() {
    return {
      data: {
        house_id: "",
        startDate: "",
        endDate: "",
        payStartDate: "",
        payEndDate: "",
        dayPayStartDate: "",
        dayPayEndDate: "",
        chargeitemID: "",
        chargeitemIDName: "",
        house: "",
      },
      startDate: "",
      endDate: "",
      payStartDate: "",
      payEndDate: "",
      excelTaskId: "",
      excelTask: false,
      modal1: false,
      loading: false,
    };
  },
  methods: {
    excelPost(type) {
      if (this.data.house_id == "") {
        this.$Message.error("房产不能为空");
        return false;
      }
      let data = this.data;
      data.targetController = "AmenityFee";
      data.taskName = "公设费收支管控表";
      if(type === 1) {
        data.targetFunction = "excelAmenityFee";
      } else {
        data.targetFunction = "excelAmenityFeeVertical";
      }
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          this.$store.commit("excelTaskAdd");
          this.$Message.success("创建导出任务成功");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$Message.error("导出失败");
          ERP.hideLoading();
        });
    },
    //选择房产
    houses() {
      let _this = this;
      this.$refs.house.show([], function (data) {
        //整理项目和房产ID
        _this.$myhttp
          .post("admin/common/house_tree_id", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            _this.data.house_id = backdata.data.house_ids;
            _this.data.house = backdata.data.ancestor_name;
            // _this.data.chargeitemID = "";
            // _this.data.chargeitemIDName = "";
            // _this.data.charge_id = "";
            // _this.data.chargeName = "";
          })
          .catch(function (error) {
            _this.$Message.error("选择房产失败");
          });
      });
    },
    houses_del() {
      this.data.house_id = "";
      this.data.house = "";
    },
    //选择收费项目
    chargeitems() {
      this.$refs.chargeitem.getInvo(this.data);
    },
    chargeitems_del() {
      this.data.chargeitemID = "";
      this.data.chargeitemIDName = "";
    },
    chargeitemAll() {
      let data = this.$refs.chargeitem.getReturn();
      this.data.chargeitemID = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeitemIDName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
};
</script>

<style>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.dade-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.d-flex-right {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/AmenityFee/form.vue